import AbstractCondition, { addError } from 'cio/app-models/conditions/abstract';
import EventAttributeCondition from 'cio/app-models/conditions/event-attribute';
import RefinementCondition from 'cio/app-models/conditions/refinement';
import { all, any } from 'cio/app-models/conditions/group';
import { isBlank } from '@ember/utils';
import { tracked } from '@glimmer/tracking';
import { computed } from '@ember/object';
import { action } from '@ember/object';

export default class EventCondition extends AbstractCondition {
  type = 'event';

  trackedAttributes = ['name', 'inverse', 'filterOperator', 'isForeignEvent'];

  @tracked name = '';
  @tracked inverse = false;
  @tracked refinement: RefinementCondition | null = null;
  @tracked filters: EventAttributeCondition[] = [];
  @tracked filterOperator: typeof all | typeof any = all;

  @tracked isForeignEvent = false;

  @computed('refinement', 'filters.[]')
  get children() {
    let { refinement, filters } = this;

    return [refinement, ...filters];
  }

  @computed('shouldValidate', 'name')
  get errors(): Record<string, string[]> {
    let errors = {};

    if (this.shouldValidate) {
      if (isBlank(this.name)) {
        addError(errors, 'name', "can't be blank");
      }
    }

    return errors;
  }

  @action
  duplicate() {
    let duplicate = EventCondition.create();
    this.copyAllAttributes(this, duplicate);
    return duplicate;
  }

  copyAllAttributes(source: EventCondition, target: EventCondition) {
    target.setProperties({
      _event: this.event,
      name: source.name,
      inverse: source.inverse,
      isForeignEvent: source.isForeignEvent,
      refinement: source.refinement?.duplicate() ?? null,
      filterOperator: source.filterOperator,
      filters: this.copyFilters(source.filters),
    });
  }

  private copyFilters(originalFilters: EventAttributeCondition[]) {
    let filters = [];
    for (let i = 0; i < originalFilters.length; i++) {
      let filter = originalFilters[i].duplicate();
      filters.push(filter);
    }
    return filters;
  }

  toString() {
    return 'EventCondition';
  }
}
